// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const {
  FETCH_TARGET_CONDITIONS_DONE,
  FETCH_TARGET_CONDITION_DONE,
  CREATE_TARGET_CONDITION_DONE,
  PATCH_TARGET_CONDITION_DONE
} = require('constants/ActionConstants').default
import { captureException } from 'utils/SentryHelpers'
import { fetchTargets as fetchTargetsEndPoint, fetchTarget as fetchTargetEndPoint, createTarget, patchTarget } from 'app/api/TargetAPI'

const TargetConditionQueries = Marty.createQueries({
  id: 'TargetConditionQueries',

  fetchTargets() {
    const promise = fetchTargetsEndPoint()
    promise.then(targets => {
      return this.dispatch(FETCH_TARGET_CONDITIONS_DONE, targets)
    })

    return promise.catch(error => captureException(error))
  },

  fetchTarget(id) {
    const promise = fetchTargetEndPoint(id)
    promise.then(target => {
      return this.dispatch(FETCH_TARGET_CONDITION_DONE, target)
    })

    return promise.catch(error => captureException(error))
  },

  createTarget(target) {
    const promise = createTarget(target)
    promise.then(target => {
      this.dispatch(CREATE_TARGET_CONDITION_DONE, target)
      return this.app.actions.NotificationActions.pushNotification({
        content: `You've created a new condition: ${ target.name }`
      })
    })

    promise.catch(error => captureException(error))

    return promise
  },

  updateTarget(operations, id) {
    const promise = patchTarget(operations, id)
    promise.then(target => {
      this.dispatch(PATCH_TARGET_CONDITION_DONE, target)
      return this.app.actions.NotificationActions.pushNotification({
        content: `You've updated condition: ${ target.name }`
      })
    })

    promise.catch(error => captureException(error))

    return promise
  }
})

export default TargetConditionQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/TargetConditionQueries.js